import { render, staticRenderFns } from "./DocumentsPicker.vue?vue&type=template&id=c49dea98&scoped=true&"
import script from "./DocumentsPicker.vue?vue&type=script&lang=js&"
export * from "./DocumentsPicker.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsPicker.vue?vue&type=style&index=0&id=c49dea98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49dea98",
  null
  
)

export default component.exports